import React, { useState } from "react";
import svgImages from "../../Assets/Images/svgImages";
import { useTranslation } from "react-i18next";
import { Popper, Paper, MenuList, MenuItem, Grow, ClickAwayListener } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

const { BritainSvg, GernamySvg } = svgImages;

export default function TranslateDropdown() {
  const { i18n } = useTranslation();
  const [lang, setLang] = useState("en");

  // Dropdown state
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  // Change language handler
  const handleLangChange = (language) => {
    setLang(language);
    i18n.changeLanguage(language);
    setOpen(false); // close dropdown after selection
  };

  // Hover handlers
  const handleMouseEnter = (event) => {
    setAnchorEl(event.currentTarget);
    setOpen(true);
  };
  const handleMouseLeave = () => setOpen(false);
  const handleClickAway = () => setOpen(false);

  // Fixed size wrapper for flags
  const FlagWrapper = ({ children }) => (
    <div
      style={{
        width: "20px",
        height: "20px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {children}
    </div>
  );

  const flags = {
    en: <FlagWrapper><BritainSvg /></FlagWrapper>,
    de: <FlagWrapper><GernamySvg /></FlagWrapper>,
  };

  return (
    <div
      style={{
        position: "relative",
        display: "flex",
        alignItems: "center",
        cursor: "pointer",
        gap: "8px", // spacing between flag and language text
      }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {/* Flag */}
      {flags[lang]}

      {/* Language name with arrow */}
      <span style={{ display: "flex", alignItems: "center", gap: "4px", color: "#000" }}>
        {lang.toUpperCase()}
        <KeyboardArrowDownIcon
          fontSize="small"
          style={{
            transition: "0.3s",
            transform: open ? "rotate(180deg)" : "rotate(0deg)",
          }}
        />
      </span>

      {/* Dropdown menu */}
      <Popper
        open={open}
        anchorEl={anchorEl}
        placement="bottom-start"
        transition
        disablePortal
        style={{ zIndex: 1300 }}
      >
        {({ TransitionProps }) => (
          <Grow {...TransitionProps}>
            <Paper elevation={3} style={{ padding: "4px 0" }}>
              <ClickAwayListener onClickAway={handleClickAway}>
                <MenuList
                  onMouseEnter={() => setOpen(true)}
                  onMouseLeave={handleMouseLeave}
                  style={{ minWidth: "auto", padding: 0 }}
                >
                  <MenuItem
                    onClick={() => handleLangChange("en")}
                    style={{ padding: "4px 12px", display: "flex", alignItems: "center", gap: "8px" }}
                  >
                    <FlagWrapper><BritainSvg /></FlagWrapper>
                    EN
                  </MenuItem>
                  <MenuItem
                    onClick={() => handleLangChange("de")}
                    style={{ padding: "4px 12px", display: "flex", alignItems: "center", gap: "8px" }}
                  >
                    <FlagWrapper><GernamySvg /></FlagWrapper>
                    DE
                  </MenuItem>
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </div>
  );
}
